module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAMAAAHo5CkKAAAABlBMVEUaGhoiIiJbxTWgAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAKZJREFUOMuVVFsOgDAMgvtf2o/pRh2rmMykawf0FQEQAAgOq363c9x5+wm1F04tTl4JTbbqUVofFUv9RFXctSqfia5jAS3WvbN8v7Eur3UFa9d5qmnG+GAgZgNUavKdaA+kfef4OqDm5+pogKUvrn/uuJrMJIKqVwLcXX5itKJb3yPRUyNOdde+us2PRZvtSJ9lomkJWUN+in4NKxt9LBqtpft37K4L/ygCEzzKQAwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// D:/Angular projects/memberreg/memberreg/src/assets/images/pattern9.png
// module id = ../../../../../src/assets/images/pattern9.png
// module chunks = styles